/** @format */

import React from 'react';
import { Input, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { setSelectedFormId } from 'state/slice/buttonSlice';
import { useSearchCustomers } from '../hooks/useSearchCustomers';
import CustomersTable from '../components/CustomersTable';
import CustomerProfile from './CustomerProfile';
import { SearchCustomerItem } from '../services/searchCustomer';
import Filter from 'img/ArrowsDownUp.svg';

const { Search } = Input;

const CustomersDirectoryContainer: React.FC = () => {
  const dispatch = useDispatch();

  // Get selected form ID from Redux
  const selectedFormId = useSelector(
    (state: RootState) => (state.button as any).selectedFormId
  );

  const { customers, loading, error, search } = useSearchCustomers();

  const handleSearch = (query: string) => {
    if (!query.trim()) {
      message.warning('Please enter a search query');
      return;
    }
    search(query);
  };

  const handleView = (customer: SearchCustomerItem) => {
    if (customer._id) {
      dispatch(setSelectedFormId(customer._id));
    } else {
      message.error('Customer ID not found');
    }
  };

  // Show customer profile if a customer is selected
  if (selectedFormId) {
    return <CustomerProfile />;
  }

  return (
    <div style={{ padding: '20px' }}>
      <div className='filter-container' style={{ marginBottom: '20px' }}>
        <div className='filter'>
          <img src={Filter} alt='Filter' />
        </div>

        {/* Search Input */}
        <div style={{ width: '300px', marginLeft: '10px' }}>
          <Search
            placeholder='Search by name, phone, or member ID'
            enterButton='Search'
            onSearch={handleSearch}
            loading={loading}
            allowClear
          />
        </div>
      </div>

      {error && (
        <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>
      )}

      <CustomersTable
        customers={customers}
        loading={loading}
        onView={handleView}
      />
    </div>
  );
};

export default CustomersDirectoryContainer;
